import { render, staticRenderFns } from "./EditPurchaseOrder.vue?vue&type=template&id=4beb4b89"
import script from "./EditPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./EditPurchaseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports